<template>
    <div class="demo-page-container" >
        <div v-loading="loading" style="height: 100%" >
        <!-- 列表搜索过滤 -->
        <div class="search-wrap" >
       <!--     <el-form
                :model="searchForm"
                ref="searchForm"
                class="leader-style-form"
            >
                <el-row :gutter="20">
                    <el-col :sm="6" :md="6" :lg="6" :xl="6">
                        <el-form-item
                            label="出厂编号"
                            label-width="80px"
                            prop="name"
                        >
                            <el-input
                                placeholder="请输入出厂编号"
                                class="em_inpunt"
                                maxlength="100"
                                clearable
                                v-model="searchForm.factory_no"
                            ></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col
                        class="search-btn-wrap"
                        :sm="18"
                        :md="18"
                        :lg="18"
                        :xl="18"
                    >
                        <el-button
                            size="medium"
                            type="warning"
                            @click="handleFilterList('1')"
                            >检索</el-button
                        >
                        <el-button
                            size="medium"
                            type="danger"
                            @click="handleFilterList('0')"
                            >清空</el-button
                        >
                        <el-button
                            type="primary"
                            @click="handleEditInfo({}, '新增')"
                            size="medium"
                            >添加</el-button
                        >
                    </el-col>
                </el-row>
            </el-form>-->
            <el-form
                :label-position="'left'"
                :model="searchForm"
                :inline="true"
                class="leader-style-form"
                ref="searchForm"
            >
                <el-form-item label="出场编号">
                    <el-input v-model="searchForm.factory_no" maxlength="50"></el-input>
                </el-form-item>
                <el-form-item label="设备型号">
                    <el-select v-model="searchForm.collector_model" placeholder="请选择">
                        <el-option
                            v-for="item in collector_model_options"
                            :key="item.code_value"
                            :label="item.code_name"
                            :value="item.code_value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="设备状态">
                    <el-select v-model="searchForm.collector_status" placeholder="请选择">
                        <el-option
                            v-for="item in collector_status_options"
                            :key="item.code_value"
                            :label="item.code_name"
                            :value="item.code_value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属公司">
                    <el-input v-model="searchForm.cust_name" maxlength="50"></el-input>
                </el-form-item>
                <el-form-item label="采集点名称">
                    <el-input v-model="searchForm.point_name" maxlength="50"></el-input>
                </el-form-item>

                <el-button size="medium" type="warning" class="leader-common-button"  @click="handleFilterList('1')">检索</el-button>
                <el-button size="medium" type="danger" @click="handleFilterList('0')">清空</el-button>
                <el-button type="primary" @click="handleEditInfo({}, '新增')" size="medium">添加</el-button>
                
            </el-form>
        </div>
        <!-- 列表 -->
        <div class="table-wrap">
            <el-table
                border
                :data="tableList"
                highlight-current-row
                class="leader-style-table"
                height="90%"
            >
                <el-table-column width="50" align="center" label="序号">
                    <template slot-scope="scope">
                        <span>
                            {{ (pageNum - 1) * pageSize + scope.$index + 1 }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="设备型号"
                    property="collector_model_name"
                    align="center"
                ></el-table-column>
                <el-table-column
                    label="出厂编号"
                    property="factory_no"
                    align="center"
                ></el-table-column>
                <el-table-column
                    label="设备状态"
                    property="collector_status_name"
                    align="center"
                ></el-table-column>
                <el-table-column
                    label="所属公司"
                    property="cust_name"
                    align="center"
                ></el-table-column>
                <el-table-column
                    label="采集点名称"
                    property="point_name"
                    align="center"
                    :show-overflow-tooltip='true'
                ></el-table-column>
                <el-table-column label="操作" align="center" width="210">
                    <template slot-scope="scope">
                        <div class="color-blue">
                            <el-button
                                type="text"
                                class="button-modify"
                                @click="handleEditInfo(scope.row, '修改')"
                                >修改</el-button
                            >
                            <div class="split-line"></div>
                            <el-button
                                type="text"
                                class="button-delete"
                                @click="hanleDelInfo(scope.row)"
                                >删除</el-button
                            >
                            <div class="split-line"></div>
                            <el-button
                                type="text"
                                class="button-check"
                                @click="handleEditInfo(scope.row, '查看')"
                                >查看</el-button
                            >
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                class="leader-style-pagination"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 30, 40, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalNum"
            ></el-pagination>
        </div>
        </div>
        <!-- 新增、修改、查看 -->
        <el-dialog
            class="leader-dialog"
            :title="dialogTitle"
            width="650px"
            :visible.sync="dialogStatus"
            @close="closeDiaCb"
            :close-on-click-modal="dialogTitle !== '查看' ? false : true"
        >
            <div class="plan-dialog-wrap" v-loading="diaLoading">
                <el-form
                    :model="userDetail"
                    ref="userDetail"
                    label-width="160px"
                    :rules="userDetailRule"
                    class="leader-style-form"
                >
                    <el-form-item label="设备型号" prop="collector_model">
                        <el-select
                            v-model="userDetail.collector_model"
                            :disabled="dialogTitle === '查看'"
                            class="txt_select"
                        >
                            <el-option
                                v-for="item in collectorList"
                                :key="item.code_value"
                                :label="item.code_name"
                                :value="item.code_value"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="出厂编号" prop="factory_no">
                        <el-input
                            placeholder="请输入出厂编号"
                            :disabled="dialogTitle === '查看'"
                            maxlength="50"
                            v-model.trim="userDetail.factory_no"
                            autocomplete="off"
                        ></el-input>
                    </el-form-item>
                    <div
                        style="color: red;width: 100%;text-align:center;padding: 5px 0;"
                    >
                        出厂编号规则： 集中器号+表号，例如01210178000021045028
                    </div>
                    <div
                        style="color: red;width: 100%;text-align:center;padding: 5px 0"
                    >
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;通信管理机号+C1_D1，例如12345C1_D1
                    </div>
                    <!-- <el-form-item
                        label="是否上传冻结数据"
                        prop="freeze_data_status"
                    >
                        <el-select
                            v-model="userDetail.freeze_data_status"
                            :disabled="dialogTitle === '查看'"
                            class="txt_select"
                        >
                            <el-option
                                v-for="item in freeze_dataList"
                                :key="item.code_value"
                                :label="item.code_name"
                                :value="item.code_value"
                            ></el-option>
                        </el-select>
                    </el-form-item>-->
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button
                    v-if="dialogTitle !== '查看'"
                    @click="saveUserInfo"
                    class="leader-common-button"
                    >保存</el-button
                >
                <el-button
                    @click="dialogStatus = false"
                    class="leader-common-button"
                    >取消</el-button
                >
            </div>
        </el-dialog>
    </div>
</template>
<script>
import * as api from "@/http/api-zmy.js";
import util from "@/utils/util";
export default {
    data() {
        return {
            tableList: [], //列表list
            freeze_dataList: [], //列表list
            collectorList: [], //列表list
            pageNum: 1, //页码
            pageSize: 10, //每页条数
            factory_no: 0, //出厂编号
            currentPage: 1, //当前页码
            totalNum: 0, //总条数
            loading: false, //loading状态
            dialogTitle: "新增", //弹窗title
            dialogStatus: false, //弹窗关闭状态
            diaLoading: false, //弹窗loading状态
            chooseRow: {}, //被选择的行数据
            searchForm: {
                //筛选form
                factory_no: "",
                collector_model:"",
                collector_status:"",
                point_name:"",
                cust_name:""
            },
            collector_status_options:[
                
            ],
            collector_model_options:[
                
            ],
            typeList: [],
            userDetail: {
                factory_no: "", //出厂编号
                collector_model: "", //设备型号
                freeze_data_status: "0" //是否上传冻结数据0不上传1上传
            },
            userDetailRule: {
                // collector_model: [
                //     {
                //         required: true,
                //         message: "请选择设备型号",
                //         trigger: "blur"
                //     }
                // ],
                factory_no: [
                    {
                        required: true,
                        message: "出厂编号不能为空",
                        trigger: "blur"
                    }
                ],
                freeze_data_status: [
                    {
                        required: true,
                        message: "请选择是否上传冻结数据",
                        trigger: "blur"
                    }
                ]
            }
        };
    },
    created() {
        // this.getUserTypeList();
        this.getDemoList();
        this.getCodelistByKind("freeze_data_status");
        this.getCodelistByKind("collector_model");
        this.getCollectorModel();
        this.getcollectorStatus();
    },
    methods: {
        getCollectorModel() {
            api.getCodelistByKind({
                code_kind: 'collector_model',
            }).then((res) => {
                if (res) {
                    this.collector_model_options = res.bus_json[0].codelists;
                }
            });
        },
        getcollectorStatus() {
            api.getCodelistByKind({
                code_kind: 'collector_status',
            }).then((res) => {
                if (res) {
                    this.collector_status_options = res.bus_json[0].codelists;
                }
            });
        },
        /**
         * 获取用户类型列表
         */
        getUserTypeList() {
            api.getRoleTypeList({
                code_kind: "demo_user_type"
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.typeList = res.bus_json[0].codelists;
                }
            });
        },
        /**
         * 列表条数改变回调
         */
        handleSizeChange(e) {
            this.pageNum = 1;
            this.pageSize = e;
            this.getDemoList();
        },
        /**
         * 企业列表页码改变回调
         */
        handleCurrentChange(e) {
            this.pageNum = e;
            this.getDemoList();
        },
        /**
         * 获取demo列表
         */
        getDemoList() {
            this.loading = true;
            //筛选form
            api.getfindCollectoByFactoryNo({
                pageNum: this.pageNum,
                pageSize: this.pageSize,
                factory_no: this.searchForm.factory_no,
                collector_model:this.searchForm.collector_model,
                collector_status:this.searchForm.collector_status,
                point_name:this.searchForm.point_name,
                cust_name:this.searchForm.cust_name
            }).then(res => {
                if (res && res.error_code === "0") {
                    console.log(res);
                    this.totalNum = res.bus_json.totalNum;
                    this.tableList = res.bus_json.items;
                }
                this.loading = false;
            });
        },
        /**
         * 获取电价等级列表
         * collector_model设备型号
         * freeze_data_status 是否上传冻结数据
         */
        getCodelistByKind(str) {
            api.getCodelistByKind({
                code_kind: str
            }).then(res => {
                if (str === "collector_model") {
                    if (res && res.error_code === "0") {
                        this.collectorList = res.bus_json[0].codelists;
                    }
                } else {
                    if (res && res.error_code === "0") {
                        this.freeze_dataList = res.bus_json[0].codelists;
                    }
                }
            });
        },
        /**
         * 筛选列表
         */
        handleFilterList(flag) {
            if (flag === "0") {
                this.searchForm.factory_no = "";
                this.searchForm.collector_model = "";
                this.searchForm.collector_status = "";
                this.searchForm.point_name = "";
                this.searchForm.cust_name = "";
            }
            this.pageNum = 1;
            this.pageSize= 10; //每页条数
            this.totalNum=0; //总条数
            this.getDemoList();
        },
        /**
         * 关闭弹窗回调函数
         */
        closeDiaCb() {
            this.$refs.userDetail.resetFields();
            this.userDetail.id = "";
        },
        /**
         * 点击新增、查看、修改按钮：
         * params {row<object>} 行数据
         * params {type<string>} 类型：type 新增，查看，删除
         */
        handleEditInfo(row, type) {
            if (type !== "新增") {
                this.diaLoading = true;
                this.chooseRow = row;
                this.getDetailInfo(row);
            }
            this.dialogTitle = type;
            this.dialogStatus = true;
        },
        /**
         * 获取查看信息
         */
        getDetailInfo(row) {
            api.getCollectorInfo({
                collector_id: row.collector_id
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.userDetail.factory_no = res.bus_json.factory_no;
                    this.userDetail.collector_model =
                        res.bus_json.collector_model;
                    this.userDetail.freeze_data_status =
                        res.bus_json.freeze_data_status;
                }
                this.diaLoading = false;
            });
        },
        /**
         * 保存用户信息
         */
        saveUserInfo: util.debounce(function(row) {
            this.$refs["userDetail"].validate(valid => {
                if (valid) {
                    const loading = this.$loading({
                        lock: true,
                        text: "保存中",
                        spinner: "el-icon-loading",
                        background: "rgba(0, 0, 0, 0.7)"
                    });
                    let params = {};
                    if (this.dialogTitle !== "新增") {
                        params = {
                            ...this.userDetail,
                            collector_id: this.chooseRow.collector_id
                        };
                    } else {
                        // params = {...this.userDetail, collector_id: ''};
                        params = this.userDetail;
                    }
                    api.addCollector(params).then(res => {
                        if (res && res.error_code === "0") {
                            this.$message({
                                type: "success",
                                message: res.error_msg
                            });
                            this.getDemoList();
                            this.dialogStatus = false;
                        }
                        loading.close()
                    });
                } else {
                    return false;
                }
            });
        }),
        /**
         * 删除用户信息
         */
        hanleDelInfo(row) {
            this.chooseRow = row;
            this.$confirm("确定删除这条数据吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    api.deleteCollector({
                        collector_id: row.collector_id
                    }).then(res => {
                        if (res && res.error_code === "0") {
                            this.$message({
                                type: "success",
                                message: res.error_msg
                            });
                            if (
                                this.totalNum -
                                    (this.pageNum - 1) * this.pageSize ==
                                1
                            ) {
                                this.pageNum =
                                    this.pageNum == 1
                                        ? this.pageNum
                                        : this.pageNum - 1;
                            }
                            this.getDemoList();
                        }
                    });
                })
                .catch(() => {});
        }
    }
};
</script>
<style lang="scss">
.demo-page-container {
    width: 100%;
    height: 100%;
    padding: px2Rem(20px);
    box-sizing: border-box;

    .el-pagination {
        margin-top: 20px;
    }

    // .button-green {
    //     color: #40be6c;
    // }

    // .button-red {
    //     color: #ff8971;
    // }

    // .button-blue {
    //     color: #0090e7;
    // }

    .el-select {
        width: 100%;
    }

    .split-line {
        width: 2px;
        height: 12px;
        background: #adadad;
        display: inline-block;
        margin: 0 8px;
        vertical-align: middle;
    }

    .search-btn-wrap {
        text-align: right;
        /*margin-right: 20px;*/
    }

    .search-wrap {
        /*margin-right: 20px;*/
    }
}
</style>
